import { render, staticRenderFns } from "./BackupDetailsDialog.vue?vue&type=template&id=704114f9&"
import script from "./BackupDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./BackupDetailsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports